import en from '@/locales/en.json';
import de from '@/locales/de.json';

export type Language = 'en' | 'de';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
];

const translations: Record<Language, typeof en> = { en, de };

export function getTranslations(language: Language): typeof en {
  return translations[language] ?? translations.en;
}
